import { useEffect, useRef } from 'react'
import { SDrawerOrModal, SFormUploadImage, SGeneralForms } from 'shj-components'
import { Button, message, Spin, Upload } from 'antd'
import { useSetState } from 'ahooks'
import { startWork, submitPageDetail, verifyOuterData } from '@/services/order'
import dayjs from 'dayjs'
import config from "@/config";
import { getEnums } from '@/services/homeService'
import { clone } from 'lodash-es'
interface IProps {
  title: string
  orderId: string
  open: boolean
  setOpen: (open: boolean) => void,
  reloadDetail: () => void
}
export default function SubmitWorkModal(prpos: IProps) {
  const formRef = useRef(null)
  const { open, title, setOpen, orderId } = prpos
  const [state, setState] = useSetState<any>({
    loading: false,
    errInfo: [],
    btnLoading: false,
    submitPageInfo: {},
    startWorkFileList: []
  })

  useEffect(() => {
    console.log('open---->', open)
    if (open) {
      getStartWorkFile();
      // 获取是否异常信息
      setState({ loading: true })
      verifyOuterData({
        params: {
          id: orderId,
        },
      })
        .then(res => {
          console.log('res---->', res)
          setState({ errInfo: res })
        })
        .finally(() => {
          setState({ loading: false })
        })

    }
  }, [open])
  const getStartWorkFile = async () => {
    const submitPageInfo: any = await submitPageDetail(orderId);
    submitPageInfo.hardExistFlag = submitPageInfo.hardExistFlag ? '是' : '否';
    submitPageInfo.planDisclosureDate = submitPageInfo?.planDisclosureDate?dayjs(Number(submitPageInfo?.planDisclosureDate)):"";
    onFormRef()?.setFieldsValue({ ...submitPageInfo })
    const startWorkFileEnum: any = await getEnums("pms", "com.shj.saas.pms.enums.startwork.StartWorkFile")
    let startWorkFileList: any = [];
    if (submitPageInfo?.hardFlag) {
      startWorkFileList.push(startWorkFileEnum[startWorkFileEnum.length - 1])
    } else {
      startWorkFileList = startWorkFileEnum
    }
    setState({ startWorkFileList, submitPageInfo })
  }
  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }

  const onsubmit = () => {
    onFormRef()
      ?.validateFields()
      .then(values => {
        setState({ btnLoading: true })
        values.planDisclosureDate = values.planDisclosureDate
          ? dayjs(values.planDisclosureDate).format('YYYY-MM-DD')
          : ''
        // 提交
        values.orderId = orderId
        const submitValues: any = clone(values);
        submitValues.attachmentList = [];
        submitValues.hardExistFlag = values.hardExistFlag === '是' ? true : false;
        submitValues.bizTag = state.submitPageInfo.bizTag;
        for (let index = 0; index < state.startWorkFileList.length; index++) {
          const item = state.startWorkFileList[index];
          if (submitValues[item.key]) {
            for (let j = 0; j < submitValues[item.key].length; j++) {
              const element = submitValues[item.key][j];
              submitValues.attachmentList.push({
                "bizType": item.key,//业务类型-取附件类型-对应key
                "attachmentName": item.description,//附件名称-取附件类型-对应名称
                "attachmentUrl": element.response?.data?.filePath || element?.url//附件地址
              })
            }

          }
        }
        startWork({
          data: {
            ...submitValues,
          },
        })
          .then(res => {
            message.success('提交成功');
            prpos?.reloadDetail?.()
            onCancel()
          })
          .finally(() => {
            setState({ btnLoading: false })
          })
      })
  }

  const onCancel = () => {
    onFormRef()?.resetFields()
    setOpen(false)
  }
  const beforeUpload = (file: any) => {
    if ((file.type || '').startsWith('image')) {
      if (!file.name.endsWith('.jpg') && !file.name.endsWith('.png') && !file.name.endsWith('.jpeg')) {
        message.error('图片必须是jpg/jpeg/png格式')
        return Upload.LIST_IGNORE;
      }
      return true
    }
    message.error('只能上传jpg/jpeg/png格式图片')
    return Upload.LIST_IGNORE;
  }

  const disabledDate = current => {
    return current && (current < dayjs() || current > dayjs().add(7, 'day'))
  }
  return (
    <SDrawerOrModal
      title={title}
      mode="modal"
      open={open}
      width={1000}
      onCancel={onCancel}
      antdProps={{
        footer: (
          <div>
            <Button onClick={onCancel}>取消</Button>
            <Button
              disabled={state.errInfo.length}
              style={{ marginLeft: 15 }}
              loading={state.btnLoading}
              type="primary"
              onClick={onsubmit}
            >
              提交
            </Button>
          </div>
        ),
      }}
    >
      {open && (
        <div>
          <Spin spinning={state.loading}>
            <div>
              <SGeneralForms
                ref={formRef}
                // httpOptionsFn={getOptions}
                layout={'vertical'}
                configs={[
                  {
                    formItem: [
                      {
                        spanCol: 12,
                        label: '客户名称',
                        name: 'customerName',
                        comConfig: {
                          disabled: true,
                        }
                      },
                      {
                        spanCol: 12,
                        label: '装修地址',
                        name: 'serviceAddress',
                        comConfig: {
                          disabled: true,
                        }
                      },
                      ...(state.submitPageInfo?.hardFlag ? [] : [{
                        spanCol: 12,
                        label: '类型',
                        name: 'bizTagName',
                        comConfig: {
                          disabled: true,
                        }
                      },
                      {
                        spanCol: 12,
                        label: '是否存在硬装',
                        name: 'hardExistFlag',
                        comConfig: {
                          disabled: true,
                        },
                      },
                      {
                        spanCol: 12,
                        label: '关联硬装状态',
                        name: 'relevanceHardStatus',
                        hidden: state.submitPageInfo?.hardExistFlag === '否',
                        comConfig: {
                          disabled: true,
                        }
                      }]),
                      {
                        spanCol: 12,
                        label: '预计交底日期',
                        name: 'planDisclosureDate',
                        type: 'date',
                        required: true,
                        isHideItem: state?.submitPageInfo?.expectProjectStartDate,
                        comConfig: {
                          disabledDate: disabledDate,
                          disabled: state?.submitPageInfo?.planDisclosureDate,
                        },
                      },
                      {
                        spanCol: 12,
                        label: '效果图URL',
                        name: 'effectDrawing',
                        required: state.submitPageInfo?.hardFlag,
                        comConfig: {
                          maxLength: 200
                        },
                        rules: [
                          {pattern: /^https?:\/\//, required: state.submitPageInfo?.hardFlag, message: '请输入正确的效果图URL'}
                        ]
                      },
                      //占位符
                      ...(state.submitPageInfo?.hardExistFlag === '是' ? [<div></div>] : []),
                      ...(state.startWorkFileList.map(item => {
                        return ({
                          label: item.description,
                          name: item.key,
                          spanCol: 12,
                          children: (<SFormUploadImage
                            url={config.api + '/file-web/file/upload'}
                            beforeUpload={beforeUpload}
                            accept='image/*' limit={10} />)
                        })
                      }))
                    ],
                  },
                ]}
              />
            </div>
            <div style={{ color: 'red' }}>
              {state.errInfo.length > 0 && <p style={{color: 'red'}}>异常信息：</p>}
              {state.errInfo.map((item: any, index: number) => {
                return (
                  <p style={{color: 'red'}}>
                    <span>
                      {index + 1}、{item}
                    </span>
                  </p>
                )
              })}
            </div>
          </Spin>
        </div>
      )}
    </SDrawerOrModal>
  )
}
